import React, { Component } from 'react';
import { connect } from 'react-redux';

import siteSetting from "../../config/env";
import { hairdresserActions, paymentActions } from "../../_actions";
import PhoneInput from 'react-phone-number-input';
import Switch from "react-switch";
import Lottie from 'react-lottie';
import animationData from '../../assets/animation-data/tick.json';
import { Close, InfoIcon } from '../SvgIcon';
import SlidePanel from '../shared/SlidePanel';
import './AddStaff.css';
import LocationScope, { LOCATION_SCOPE_THIS, resolveScopeSalonIds } from '../multiLocation/LocationScope';
import { readSitesCache, loadSites } from '../multiLocation/useSites';
import { sitesService } from '../../_services/sites.service';
import toast from '../shared/Toast';

const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

class AddStaff extends Component {

    constructor(props) {
        super(props);

        this.slidePanelRef = React.createRef();

        this.state = {
            // Form fields
            first_name: '',
            last_name: '',
            email: '',
            phoneNumber: '',
            jobTitle: '',
            employmentTypeId: 1,

            // Commission (self-employed only)
            showCommissions: false,
            salonCommissionRate: '',
            salonCommissionRateStatus: false,
            productCommissionRate: '',
            productCommissionRateStatus: false,
            voucherCommissionRate: '',
            voucherCommissionRateStatus: false,

            // Activation code
            activationCode: '',
            applyCoupon: false,
            isApplyedPromocode: false,
            activatationCodeError: '',
            activatationCodeSuccess: '',
            discount: 0,

            // Subscription info
            oneSelfEmpPrice: siteSetting.stripe.oneSelfEmpPrice,
            oneSelfEmpPriceBefore: siteSetting.stripe.oneSelfEmpPrice,
            planPrice: siteSetting.stripe.salonMonthlyPrice,
            planType: 'month',
            quantity: 0,

            // UI state
            success: false,
            submitting: false,

            // Errors
            fNameError: '',
            emailError: '',
            phoneNumberError: '',
            jobError: '',
            salonCommissionRateError: '',
            productCommissionRateError: '',
            voucherCommissionRateError: '',
            error: '',

            // Defaults
            salonId: localStorage.getItem('salonId'),
            countryId: '217',

            // Commission info tooltip
            showTooltip: false,
        };
    }

    componentDidMount() {
        this.subscriptionGet();
    }

    subscriptionGet = () => {
        let self = this;
        self.props.dispatch(paymentActions.subscriptionGet({}))
            .then(function (response) {
                if (response.data.statusCode === 1) {
                    let subInfo = response.data.responseData.result;
                    if (subInfo?.plan?.interval === "year") {
                        self.setState({
                            planPrice: siteSetting.stripe.salonYearlyPrice,
                            planType: "year",
                            quantity: response.data.responseData?.selfEmpPlan?.quantity || 0
                        });
                    } else {
                        self.setState({
                            quantity: response.data.responseData?.selfEmpPlan?.quantity || 0
                        });
                    }
                }
            });
    }

    handleSheetClose = () => {
        if (this.slidePanelRef.current) {
            this.slidePanelRef.current.handleClose();
        }
    }

    selectEmploymentType = (typeId) => {
        this.setState({
            employmentTypeId: typeId,
            activationCode: '',
            applyCoupon: false,
            isApplyedPromocode: false,
            activatationCodeError: '',
            activatationCodeSuccess: '',
            discount: 0,
            showCommissions: false,
            oneSelfEmpPrice: this.state.oneSelfEmpPriceBefore,
        });
    }

    validateEmail(email) {
        const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(email);
    }

    handlePhoneChange = (val) => {
        this.setState({ phoneNumber: val || '' });
    }

    onChanged = (e) => {
        const { name, value } = e.target;
        let stateUpdates = {};

        switch (name) {
            case 'first_name':
                stateUpdates.fNameError = '';
                break;
            case 'email':
                stateUpdates.emailError = '';
                break;
            case 'jobTitle':
                stateUpdates.jobError = '';
                break;
            case 'salonCommissionRate':
                stateUpdates.salonCommissionRateError = (value !== '' && (value < 0 || value > 100))
                    ? 'Commission should be between 1 and 100' : '';
                break;
            case 'productCommissionRate':
                stateUpdates.productCommissionRateError = (value !== '' && (value < 0 || value > 100))
                    ? 'Commission should be between 1 and 100' : '';
                break;
            case 'voucherCommissionRate':
                stateUpdates.voucherCommissionRateError = (value !== '' && (value < 0 || value > 100))
                    ? 'Commission should be between 1 and 100' : '';
                break;
            case 'activationCode':
                stateUpdates.isApplyedPromocode = false;
                stateUpdates.discount = 0;
                stateUpdates.activatationCodeSuccess = '';
                stateUpdates.oneSelfEmpPrice = this.state.oneSelfEmpPriceBefore;
                break;
            default:
                break;
        }

        this.setState({
            [name]: value,
            ...stateUpdates,
        });
    }

    onChangeSalonCommissionRate = (checked) => {
        this.setState({
            salonCommissionRateStatus: checked,
            salonCommissionRate: checked ? this.state.salonCommissionRate : '',
            salonCommissionRateError: '',
        });
    }

    onChangeProductCommissionRate = (checked) => {
        this.setState({
            productCommissionRateStatus: checked,
            productCommissionRate: checked ? this.state.productCommissionRate : '',
            productCommissionRateError: '',
        });
    }

    onChangeVoucherCommissionRate = (checked) => {
        this.setState({
            voucherCommissionRateStatus: checked,
            voucherCommissionRate: checked ? this.state.voucherCommissionRate : '',
            voucherCommissionRateError: '',
        });
    }

    showActivationCode = () => {
        this.setState({ applyCoupon: !this.state.applyCoupon });
    }

    applyCoupan = () => {
        this.setState({
            activatationCodeError: '',
            activatationCodeSuccess: '',
        });
        let self = this;
        if (this.state.activationCode.trim() !== "") {
            self.props.dispatch(paymentActions.activationCode({ activationCode: self.state.activationCode.trim() }))
                .then(function (response) {
                    if (response.data.statusCode == 0) {
                        self.setState({
                            activatationCodeError: 'Activation code "' + self.state.activationCode + '" does not exist'
                        });
                    } else {
                        let discount = 0, totalPayment = self.state.oneSelfEmpPriceBefore;
                        if (response.data.responseData.result.percent_off) {
                            discount = (response.data.responseData.result.percent_off / 100) * totalPayment;
                            totalPayment = totalPayment - discount;
                        }
                        if (response.data.responseData.result.amount_off) {
                            discount = response.data.responseData.result.amount_off / 100;
                            totalPayment = totalPayment - discount;
                        }
                        self.setState({
                            discount,
                            oneSelfEmpPrice: totalPayment,
                            isApplyedPromocode: true,
                            activatationCodeSuccess: "Activation code applied successfully"
                        });
                    }
                });
        } else {
            self.setState({
                activatationCodeError: "Please enter activation code",
            });
        }
    }

    addStaff = () => {
        // Validate all fields at once
        let errors = {};
        let hasError = false;

        if (!this.state.first_name) {
            errors.fNameError = 'Please enter first name';
            hasError = true;
        }
        if (!this.state.email) {
            errors.emailError = 'Please enter email address';
            hasError = true;
        } else if (!this.validateEmail(this.state.email)) {
            errors.emailError = 'Please enter a valid email address';
            hasError = true;
        }
        if (!this.state.phoneNumber) {
            errors.phoneNumberError = 'Please enter a valid phone number';
            hasError = true;
        }
        if (!this.state.jobTitle) {
            errors.jobError = 'Please enter a job title';
            hasError = true;
        }
        if (this.state.salonCommissionRateStatus && (this.state.salonCommissionRate === '' || this.state.salonCommissionRate < 0 || this.state.salonCommissionRate > 100)) {
            errors.salonCommissionRateError = 'Commission should be between 1 and 100';
            hasError = true;
        }
        if (this.state.productCommissionRateStatus && (this.state.productCommissionRate === '' || this.state.productCommissionRate < 0 || this.state.productCommissionRate > 100)) {
            errors.productCommissionRateError = 'Commission should be between 1 and 100';
            hasError = true;
        }
        if (this.state.voucherCommissionRateStatus && (this.state.voucherCommissionRate === '' || this.state.voucherCommissionRate < 0 || this.state.voucherCommissionRate > 100)) {
            errors.voucherCommissionRateError = 'Commission should be between 1 and 100';
            hasError = true;
        }

        // Clear previous errors and set new ones
        this.setState({
            error: '',
            emailError: '',
            fNameError: '',
            phoneNumberError: '',
            jobError: '',
            salonCommissionRateError: '',
            productCommissionRateError: '',
            voucherCommissionRateError: '',
            ...errors,
        });

        if (hasError) return;

        // Submit
        this.setState({ submitting: true });
        let self = this;
        let data = new FormData();
        data.append('name', this.state.first_name + " " + this.state.last_name);
        data.append('first_name', this.state.first_name);
        data.append('last_name', this.state.last_name);
        data.append('email', this.state.email);
        data.append('phoneNumber', this.state.phoneNumber);
        data.append('jobTitle', this.state.jobTitle);
        data.append('hairdresserBookingInterval', 15);
        data.append('shortBio', '');
        data.append('employmentTypeId', this.state.employmentTypeId);
        data.append('salonId', this.state.salonId);
        data.append('countryId', this.state.countryId);
        data.append('currency', 'GBP');
        data.append('currencySymbol', '£');
        data.append('currencyCountry', 'GB');
        data.append('salonCommissionRate', this.state.salonCommissionRate !== '' ? this.state.salonCommissionRate : 0);
        data.append('productCommissionRate', this.state.productCommissionRate !== '' ? this.state.productCommissionRate : 0);
        data.append('voucherCommissionRate', this.state.voucherCommissionRate !== '' ? this.state.voucherCommissionRate : 0);
        data.append('activationCode', this.state.activationCode);

        self.props.dispatch(hairdresserActions.addStaff(data))
            .then(function (response) {
                if (response.data.statusCode === 1) {
                    self.setState({
                        success: true,
                        submitting: false,
                    });
                    // Locations control: also give them a staff record at the
                    // chosen sites (services copied from here). Found by email
                    // in the group staff list — the create response carries no id.
                    self.addToOtherSites(response.data.responseData);
                } else {
                    self.setState({
                        submitting: false,
                        emailError: response.data.error.responseMessage || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                self.setState({
                    submitting: false,
                    error: 'Something went wrong. Please try again.'
                });
            });
    }

    addToOtherSites = async (created) => {
        try {
            const scope = this.state.locScope;
            if (!scope || scope.mode === 'this') return;
            const d = readSitesCache() || await loadSites(false);
            const sites = (d && d.sites) || [];
            if (sites.length < 2) return;
            const active = sites.find((s) => s.isActive);
            const targets = resolveScopeSalonIds(scope, sites, active && active.salonId);
            if (!targets.length) return;
            let userId = created && (created.userId || (created.result && (created.result.userId || created.result._id)));
            if (!userId) {
                const email = String(this.state.email || '').trim().toLowerCase();
                const r = await sitesService.groupStaff();
                const hit = (r && r.staff || []).find((p) => String(p.email || '').toLowerCase() === email);
                userId = hit && hit.userId;
            }
            if (!userId) { toast.error('Added here, but could not add them to the other locations — use "Works at" on their profile.'); return; }
            const names = [];
            for (const salonId of targets) {
                try { await sitesService.addStaffToSite({ userId, salonId, sourceSalonId: localStorage.getItem('salonId') }); names.push((sites.find((s) => String(s.salonId) === String(salonId)) || {}).salonName); }
                catch (e) { /* one site failing should not hide the others */ }
            }
            if (names.length) toast.success(`Also added at ${names.filter(Boolean).join(', ')}`);
        } catch (e) { /* best effort */ }
    }

    showTooltip = () => {
        this.setState({ showTooltip: true });
    }

    hideTooltip = () => {
        this.setState({ showTooltip: false });
    }

    renderEmploymentCards() {
        const { employmentTypeId } = this.state;
        return (
            <div className="as-type-cards">
                <div
                    className={`as-type-card ${employmentTypeId === 1 ? 'as-type-card--active' : ''}`}
                    onClick={() => this.selectEmploymentType(1)}
                >
                    <div className="as-type-card-header">
                        <h4 className="as-type-card-title">Employed</h4>
                        <span className="as-type-card-badge as-type-card-badge--included">Included</span>
                    </div>
                    <p className="as-type-card-desc">Paid into the salon account</p>
                </div>

                <div
                    className={`as-type-card ${employmentTypeId === 2 ? 'as-type-card--active' : ''}`}
                    onClick={() => this.selectEmploymentType(2)}
                >
                    <div className="as-type-card-header">
                        <h4 className="as-type-card-title">Self-employed</h4>
                        <span className="as-type-card-badge as-type-card-badge--price">+£{siteSetting.stripe.oneSelfEmpPrice}/mo</span>
                    </div>
                    <p className="as-type-card-desc">Paid directly into their own account. Commissions split automatically at point of sale.</p>
                </div>
            </div>
        );
    }

    renderPricingSummary() {
        const { quantity, planType, oneSelfEmpPrice, oneSelfEmpPriceBefore, discount } = this.state;

        return (
            <div className="as-pricing-summary">
                <div className="as-pricing-row">
                    <span className="as-pricing-label">Current plan</span>
                    <span className="as-pricing-value">
                        {quantity > 0 ? `Salon + ${quantity} self-employed` : 'Salon'}
                    </span>
                </div>
                <div className="as-pricing-row">
                    <span className="as-pricing-label">New plan</span>
                    <span className="as-pricing-value as-pricing-value--bold">
                        Salon + {quantity + 1} self-employed
                    </span>
                </div>
                <div className="as-pricing-row">
                    <span className="as-pricing-label">Additional cost</span>
                    <span className="as-pricing-value as-pricing-value--highlight">
                        £{oneSelfEmpPrice}/{planType === 'year' ? 'yr' : 'mo'}
                        {discount > 0 && <strike>£{oneSelfEmpPriceBefore}</strike>}
                    </span>
                </div>
                <p className="as-pricing-note">Billed {planType === 'year' ? 'annually' : 'monthly'}, cancel anytime.</p>
            </div>
        );
    }

    renderActivationCode() {
        const { applyCoupon, activatationCodeError, activatationCodeSuccess, isApplyedPromocode, activationCode } = this.state;

        return (
            <div className="as-activation-section">
                {!applyCoupon ? (
                    <button className="as-activation-toggle" onClick={this.showActivationCode}>
                        Have an activation code?
                    </button>
                ) : (
                    <>
                        <div className="as-activation-wrap">
                            <input
                                className="es-input"
                                placeholder="Enter activation code"
                                name="activationCode"
                                value={activationCode}
                                onChange={this.onChanged}
                            />
                            <button
                                className="as-activation-apply"
                                onClick={this.applyCoupan}
                                disabled={isApplyedPromocode}
                            >
                                Apply
                            </button>
                        </div>
                        {activatationCodeError && (
                            <p className="as-activation-msg as-activation-msg--error">{activatationCodeError}</p>
                        )}
                        {activatationCodeSuccess && (
                            <p className="as-activation-msg as-activation-msg--success">{activatationCodeSuccess}</p>
                        )}
                    </>
                )}
            </div>
        );
    }

    renderCommissions() {
        const { showCommissions, showTooltip } = this.state;

        return (
            <div>
                <div className="as-commissions-toggle" onClick={() => this.setState({ showCommissions: !showCommissions })}>
                    <span className="as-commissions-toggle-label">Commissions</span>
                    <svg className={`as-commissions-chevron ${showCommissions ? 'as-commissions-chevron--open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                </div>

                <div className={`as-commissions-body ${showCommissions ? 'as-commissions-body--open' : ''}`}>
                    <div className="as-commissions-inner">
                        <div className="as-commissions-header">
                            <span className="as-commissions-desc">Set commission rates for this team member</span>
                            <button className="es-info-btn" onClick={this.showTooltip}>
                                <InfoIcon />
                            </button>
                        </div>

                        {showTooltip && (
                            <div className="es-info-box as-commissions-info">
                                <button className="es-info-close" onClick={this.hideTooltip}><Close /></button>
                                <p><b>Booking Commission</b> - paid to the salon manager by the self-employed staff member at point of sale.</p>
                                <p><b>Product Commission</b> - paid to the self-employed staff member on product profit (retail price minus stock price).</p>
                                <p><b>Voucher Commission</b> - paid to the self-employed staff member on voucher sales.</p>
                            </div>
                        )}

                        <div className="es-commission-card">
                            {/* Booking Commission */}
                            <div className="es-commission-item">
                                <div className="es-commission-left">
                                    <span className="es-commission-name">Booking</span>
                                    <span className="es-commission-desc">Paid to salon</span>
                                </div>
                                <div className="es-commission-right">
                                    {this.state.salonCommissionRateStatus && (
                                        <div className="es-commission-input-wrap">
                                            <input
                                                type="number"
                                                className="es-input es-commission-input"
                                                value={this.state.salonCommissionRate}
                                                name="salonCommissionRate"
                                                onChange={this.onChanged}
                                            />
                                            <span className="es-commission-unit">%</span>
                                        </div>
                                    )}
                                    <Switch
                                        onColor="#007EA0"
                                        onChange={this.onChangeSalonCommissionRate}
                                        checked={this.state.salonCommissionRateStatus}
                                        height={24}
                                        width={44}
                                        handleDiameter={20}
                                    />
                                </div>
                            </div>
                            {this.state.salonCommissionRateError && (
                                <div className="as-commission-error">
                                    <span className="es-error">{this.state.salonCommissionRateError}</span>
                                </div>
                            )}

                            {/* Product Commission */}
                            <div className="es-commission-item">
                                <div className="es-commission-left">
                                    <span className="es-commission-name">Product</span>
                                    <span className="es-commission-desc">Paid to staff</span>
                                </div>
                                <div className="es-commission-right">
                                    {this.state.productCommissionRateStatus && (
                                        <div className="es-commission-input-wrap">
                                            <input
                                                type="number"
                                                className="es-input es-commission-input"
                                                value={this.state.productCommissionRate}
                                                name="productCommissionRate"
                                                onChange={this.onChanged}
                                            />
                                            <span className="es-commission-unit">%</span>
                                        </div>
                                    )}
                                    <Switch
                                        onColor="#007EA0"
                                        onChange={this.onChangeProductCommissionRate}
                                        checked={this.state.productCommissionRateStatus}
                                        height={24}
                                        width={44}
                                        handleDiameter={20}
                                    />
                                </div>
                            </div>
                            {this.state.productCommissionRateError && (
                                <div className="as-commission-error">
                                    <span className="es-error">{this.state.productCommissionRateError}</span>
                                </div>
                            )}

                            {/* Voucher Commission */}
                            <div className="es-commission-item as-commission-last">
                                <div className="es-commission-left">
                                    <span className="es-commission-name">Voucher</span>
                                    <span className="es-commission-desc">Paid to staff</span>
                                </div>
                                <div className="es-commission-right">
                                    {this.state.voucherCommissionRateStatus && (
                                        <div className="es-commission-input-wrap">
                                            <input
                                                type="number"
                                                className="es-input es-commission-input"
                                                value={this.state.voucherCommissionRate}
                                                name="voucherCommissionRate"
                                                onChange={this.onChanged}
                                            />
                                            <span className="es-commission-unit">%</span>
                                        </div>
                                    )}
                                    <Switch
                                        onColor="#007EA0"
                                        onChange={this.onChangeVoucherCommissionRate}
                                        checked={this.state.voucherCommissionRateStatus}
                                        height={24}
                                        width={44}
                                        handleDiameter={20}
                                    />
                                </div>
                            </div>
                            {this.state.voucherCommissionRateError && (
                                <div className="as-commission-error">
                                    <span className="es-error">{this.state.voucherCommissionRateError}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSuccess() {
        return (
            <>
                <div className="es-body as-success">
                    <Lottie
                        options={defaultOptions}
                        height={100}
                        width={100}
                    />
                    <h3>Team member added</h3>
                    <p>You can update their details, photo, and schedule from the team page.</p>
                </div>
                <div className="es-footer">
                    <button className="es-btn-primary" onClick={() => this.slidePanelRef.current?.handleClose()}>
                        Go to team
                    </button>
                </div>
            </>
        );
    }

    renderForm() {
        const { employmentTypeId, submitting } = this.state;
        const isSelfEmployed = employmentTypeId === 2;

        return (
            <>
                <div className="es-header">
                    <h3 className="es-header-title">Add team member</h3>
                    <button className="es-close-btn" onClick={() => this.slidePanelRef.current?.handleClose()} type="button">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                <div className="es-body">
                    {this.renderEmploymentCards()}

                    <div className="es-form">
                        {this.state.error && (
                            <div className="es-error as-form-error">{this.state.error}</div>
                        )}

                        <LocationScope value={this.state.locScope || LOCATION_SCOPE_THIS} onChange={(v) => this.setState({ locScope: v })} label="Works at" help="A staff record at each chosen location, with these services copied. Commission, rota and pay are set per location." />

                        {/* First Name + Surname */}
                        <div className="es-row">
                            <div className="es-field">
                                <label className="es-label">First name</label>
                                <input
                                    type="text"
                                    className="es-input"
                                    name="first_name"
                                    value={this.state.first_name}
                                    onChange={this.onChanged}
                                    placeholder="First name"
                                />
                                {this.state.fNameError && <span className="es-error">{this.state.fNameError}</span>}
                            </div>
                            <div className="es-field">
                                <label className="es-label">Surname</label>
                                <input
                                    type="text"
                                    className="es-input"
                                    name="last_name"
                                    value={this.state.last_name}
                                    onChange={this.onChanged}
                                    placeholder="Surname"
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="es-field">
                            <label className="es-label">Email</label>
                            <input
                                type="email"
                                className="es-input"
                                name="email"
                                value={this.state.email}
                                onChange={this.onChanged}
                                placeholder="email@example.com"
                            />
                            {this.state.emailError && <span className="es-error">{this.state.emailError}</span>}
                        </div>

                        {/* Phone */}
                        <div className="es-field">
                            <label className="es-label">Phone</label>
                            <PhoneInput
                                international={true}
                                defaultCountry="GB"
                                className="es-input es-phone-input"
                                placeholder="Phone number"
                                name="phoneNumber"
                                value={this.state.phoneNumber}
                                onChange={this.handlePhoneChange}
                            />
                            {this.state.phoneNumberError && <span className="es-error">{this.state.phoneNumberError}</span>}
                        </div>

                        {/* Job Title */}
                        <div className="es-field">
                            <label className="es-label">Job title</label>
                            <input
                                type="text"
                                className="es-input"
                                name="jobTitle"
                                value={this.state.jobTitle}
                                onChange={this.onChanged}
                                placeholder="e.g. Senior Stylist"
                            />
                            {this.state.jobError && <span className="es-error">{this.state.jobError}</span>}
                        </div>

                        {/* Self-employed extras */}
                        {isSelfEmployed && (
                            <>
                                {this.renderPricingSummary()}
                                {this.renderCommissions()}
                                {this.renderActivationCode()}
                            </>
                        )}
                    </div>
                </div>

                <div className="es-footer">
                    <button
                        className="es-btn-primary"
                        onClick={this.addStaff}
                        disabled={submitting}
                    >
                        {submitting ? 'Adding...' : 'Add team member'}
                    </button>
                </div>
            </>
        );
    }

    render() {
        return (
            <SlidePanel ref={this.slidePanelRef} onClose={() => this.props.onClose && this.props.onClose(this.state.success)}>
                {this.state.success ? this.renderSuccess() : this.renderForm()}
            </SlidePanel>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(AddStaff);
